import { render, staticRenderFns } from "./trDetail.vue?vue&type=template&id=170957ff&scoped=true"
import script from "./trDetail.vue?vue&type=script&lang=js"
export * from "./trDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170957ff",
  null
  
)

export default component.exports